<template>
  <div class="product-options__root">
    <template
      v-for="option in productOptions"
      :key="`option-${option.id}`"
    >
      <ProductOption
        :product-option="option"

        @updateOptions="updateOptionsList"
      />
    </template>
  </div>
</template>

<script setup lang="ts">
import type { IProductOption } from '#sitis/internal/controllers/products/models/ProductOptions';
import ProductOption from '~/components/products/ProductOption.vue';
import type { IExtendedProductOptionsVariant } from '~/pages/product/[...slug].vue';

const { productOptions } = defineProps<{
	productOptions:IProductOption[];
}>();

const emit = defineEmits<{
	updateOptionsList:[options:IExtendedProductOptionsVariant[]]
}>();

const optionsList = ref<IExtendedProductOptionsVariant[] | []>([]);
const updateOptionsList = (opt:IExtendedProductOptionsVariant) => {
  const index = optionsList.value.findIndex((t) => Number(t.productOptionId) === Number(opt.productOptionId));

  if (index === -1) {
    /// @ts-ignore
    optionsList?.value?.push(opt);
  } else {
    optionsList.value[index] = opt;
  }

  if (optionsList.value.length) {
    emit('updateOptionsList', optionsList.value as IExtendedProductOptionsVariant[]);
  }
};
</script>

<style scoped lang="scss">
.product-options__root{
  display: flex;
  flex-direction: column;
  gap: 14px;
}
</style>
